export const OLD_SUPPORT_ACCOUNT_PREFIX = 'InGame_Support';
export const SUPPORT_ACCOUNT_POSTFIX = '@ingame-support.com';
